
  <h2 mat-dialog-title>An Error has occurred</h2>
  <mat-dialog-content>An unexpected error has occurred and the CareApp dashboard needs to reload.
  We apologise for this inconvenience. This error has been reported.</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button
    (click)="close()" mat-dialog-close>Reload Dashboard</button>
  </mat-dialog-actions>
    